export const siteConfig = {
  knowledgeBase: {
    url: 'http://siyuan.quentinyuan.online/',
    authCode: '123123',
  },
  blog: {
    url: 'http://blog.quentinyuan.online/',
  },
  // url: 'http://piggybank.quentinyuan.online/',
  projects: [
    {
      id: 'piggy-bank',
      name: '猪猪银行',
      description: '一个可爱的银行管理系统',
      icon: '🐷',
      url: '/piggy_bank/zhuzhu2.html',
    },
  ],
};
